export default __webpack_public_path__ + "static/media/water.13b5ea43.png";